import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useState } from 'react';
import Api from '../../Api';

interface FileUploadProps {
    auditId: string
    disabled: boolean,
    onImported?: (r: any) => void,
}

const FileUpload: React.FC<FileUploadProps> = ({ auditId, disabled, onImported }) => {
    const [file, setFile] = useState<File | null>(null);
    const [error, setError] = useState<string>();
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const handleModalOpen = () => setModalOpen(true);
    const handleModalClose = () => setModalOpen(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setFile(event.target.files[0]);
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append('File', file);
        formData.append('EntityId', auditId);
        formData.append('EntityType', "AUDIT");

        try {
            const response = await Api.Audits.import(formData);


            console.log("audit import", response);

            if (onImported)
                onImported(response);
            handleModalClose();
            setFile(null);
        } catch (error) {
            console.error("Error uploading file:", error);
            setError("import failed");
        }
    };

    return (
        <div>
            <Button size="small" variant="outlined" color="info" disabled={disabled} onClick={handleModalOpen}>
                Import
            </Button>
            <Dialog open={modalOpen} onClose={handleModalClose}>
                <DialogTitle>Import Audit Results Data</DialogTitle>
                <DialogContent>
                    {error &&
                        <Alert severity="error">
                            {error}
                        </Alert>
                    }
                    <Box component="form" onSubmit={handleSubmit} noValidate>
                        <TextField
                            margin="dense"
                            id="file"
                            type="file"
                            fullWidth
                            onChange={handleFileChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            required
                        />



                        <DialogActions>
                            <Button onClick={handleModalClose} color="warning">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary">
                                Upload
                            </Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default FileUpload;